import { render, staticRenderFns } from "./TeacherClassSettings.vue?vue&type=template&id=3a318d2e&"
import script from "./TeacherClassSettings.vue?vue&type=script&lang=js&"
export * from "./TeacherClassSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports